import React from 'react'
import { t } from '@/utils/i18n'
import styles from './CloudAttrs.module.less'

interface CloudAttrItem {
  [key: string]: string
}
interface CloudAttrsProps {
  attrList: CloudAttrItem[]
}

// 货品详细自定义属性
const CloudAttrs: React.FC<CloudAttrsProps> = (props) => {
  const { attrList } = props

  const DescriptionItem = () => {
    return attrList.filter(item => item.value).map((item: CloudAttrItem, index: number) => (
      <div className={styles['text-item']} key={index}>
        <div className={styles['label']}>{item.label}</div>
        <div className={styles['value']}>
          {item.value}
        </div>
      </div>
    ))
  }

  return (
    <div className={styles['card-wrap']}>
      <h2 className={styles['title']}>{t('货品属性')}</h2>
      <div className={styles['text-list']}>
        <DescriptionItem />
      </div>
    </div>
  )
}

export default CloudAttrs